import jQuery from 'jquery';

window.$j = jQuery.noConflict();
window.jQuery = jQuery.noConflict();

import '../3rd_party/cookie_handling.js';
import '../3rd_party/requestidlecallback_shim.js';
